var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"book-user-state-badge",attrs:{"data-status":_vm.presentation.status}},[(_vm.presentation.icon)?_c('i',{staticClass:"fas",class:`fa-${_vm.presentation.icon}`,attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.presentation.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }